export default "__VITE_ASSET__op5lQpsv__"